import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import {NavLink} from 'react-router-dom';
import $ from "jquery";

import { DatePicker } from 'material-ui-pickers';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Switch from '@material-ui/core/Switch';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import ClinicalHistoryModalBox from '../Common/Modals/ClinicalHistoryModalBox';
import {stableSort, getSorting, isFutureDate} from '../Common/helpers';
import {validateForm, blurValidations} from '../Common/formValidator';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ServiceModalBox from '../Common/Modals/ServiceModalBox';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';

import './style.css';

var moment = require('moment');

class AddEditClient extends Component {
    date = moment();
    state = {
        clientId:this.props.props.match.params.id
        ,openModal:false
        ,order:'asc'
        ,orderBy:'StaffId'
        ,page:0
        ,rowsPerPage:5
        ,returnTitle: "Erro"
        ,returnText: "Ocorreu algum erro"
        ,clinicalHistoryOpenModal:false
        ,serviceOpenModal:false
        ,serviceTitle: ""
        ,clientServiceId: ""
        ,modalServiceId: ""
        ,getOldClientServices:""
        ,priceWithVat:""
        ,editable: (this.props.isAdmin || this.props.loginData.profile.Clients.permission === 1)
        ,somethingWasEdited: false
        ,clientData:null
        ,fetchServices:null
        ,loading:false
        ,addEditTitle:"Novo Cliente"
        ,cId:""
        ,profilePic:""
        ,firstName:""
        ,lastName:""
        ,profession:""
        ,fullName:""
        ,gender:"M"
        ,dateOfBirth:this.date
        ,dateClientSince:this.date
        ,dateClientRegistered:this.date
        ,invoiceNumber:""
        ,idNumber:""
        ,financeNumber:""
        ,iban:""
        ,homePhone:""
        ,cellPhone:""
        ,homeAddress:""
        ,email:""
        ,notes:""
        ,globalNotes:""
        ,isActive:"1"
    };

    componentDidMount() {
        const { clientId } = this.state;

        if(clientId==="New"){
            fetch(API + "getservices")
            .then(response => response.json())
            .then(result => this.setState({ fetchServices: result.data }));
        }else{
            const fetches = [
                fetch(API + "getclients&getpic=true&getbyid=" + clientId)
                , fetch(API + "getservices")
                , fetch(API + "getclientservices&clientid=" + clientId)
            ];

            Promise.all(fetches)
            .then(responses => Promise.all(responses.map(r => r.json())))
            .then(result => {
                const clientData = result[0].data;
                
                if(result === null || result[0].shortmsg === "NOK"){
                    this.props.props.history.push('/Clients');
                    return;
                }
                
                this.setState({ 
                    clientData
                    , fetchServices: result[1].data 
                    , serviceData: result[2].data 
                    , cId: clientData.ClientId
                    , profilePic: clientData.ProfilePicture || this.state.profilePic
                    , firstName: clientData.FirstName || this.state.firstName  
                    , lastName: clientData.LastName || this.state.lastName 
                    , profession: clientData.Profession || this.state.profession  
                    , fullName: clientData.FullName || this.state.fullName  
                    , gender: clientData.Gender || this.state.gender  
                    , dateOfBirth: clientData.DateBirth || this.state.dateOfBirth  
                    , dateClientSince: clientData.DateClientSince || this.state.dateClientSince  
                    , dateClientRegistered: clientData.DateCreated || this.state.dateClientRegistered 
                    , invoiceNumber: clientData.InvoiceNumber || this.state.invoiceNumber
                    , idNumber: clientData.IdNumber || this.state.idNumber  
                    , financeNumber: clientData.FinanceNumber || this.state.financeNumber  
                    , iban: clientData.IBAN || this.state.iban  
                    , homePhone: clientData.HomePhone || this.state.homePhone  
                    , cellPhone: clientData.CellPhone || this.state.cellPhone  
                    , homeAddress: clientData.HomeAddress || this.state.homeAddress  
                    , email: clientData.Email || this.state.email  
                    , notes: clientData.Notes || this.state.notes  
                    , globalNotes: clientData.GlobalNotes || this.state.globalNotes  
                    , isActive: clientData.IsActive
                })
            });
        }
        blurValidations($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false });
    }

    getClientServices = (getOldServices) => {
        let query = "getclientservices&clientid="+this.state.clientId
        if(getOldServices==="1"){
            query += "&showolddates=true";
        }
        fetch(API + query)
        .then(response => response.json())
        .then(result => {this.setState({ serviceData: result.data, getOldClientServices: getOldServices});});
    }

    handleTitleChange = (e) => this.setState({ [e.target.id]: e.target.value, addEditTitle: e.target.value, somethingWasEdited:true });
    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0", somethingWasEdited:true });
    handleRadioChange = (e) => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleOldServiceChange = (e, value) => this.getClientServices(value ? "1" : "0");
    handleUploadImage = (evt) => {
        var tgt = evt.target || window.event.srcElement,
            files = tgt.files;

        // FileReader support
        if (FileReader && files && files.length) {
            var fr = new FileReader();
            fr.onload = () => {
                $(findDOMNode(this.refs.profilePic)).attr("src", fr.result);
                this.setState({ profilePic: fr.result, somethingWasEdited:true });
            }
            fr.readAsDataURL(files[0]);
        }

        // Not supported
        else {
            alert("Este browser não permite upload de imagens. Tente noutro browser.");
        }
    }

    handleSave = (e) => {
        if(!this.state.somethingWasEdited)
            return;

        if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: false, showErrorMessage: true, dumbValidations: false })){
            fetch(API + "saveclient", {
                method: 'POST'
                ,headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
                ,body: JSON.stringify({
                    clientid:this.state.clientId
                    ,cid:this.state.cId
                    ,profilepic:this.state.profilePic.trim()
                    ,firstname:this.state.firstName.trim()
                    ,lastname:this.state.lastName.trim()
                    ,profession:this.state.profession.trim()
                    ,fullname:this.state.fullName.trim()
                    ,gender:this.state.gender
                    ,dateofbirth:moment(this.state.dateOfBirth).format('YYYY-MM-DD')
                    ,dateclientsince:moment(this.state.dateClientSince).format('YYYY-MM-DD')
                    ,invoicenumber:this.state.invoiceNumber.trim()
                    ,idnumber:this.state.idNumber
                    ,financenumber:this.state.financeNumber
                    ,iban:this.state.iban.trim()
                    ,homephone:this.state.homePhone.trim()
                    ,cellphone:this.state.cellPhone.trim()
                    ,homeaddress:this.state.homeAddress.trim()
                    ,email:this.state.email.trim()
                    ,notes:this.state.notes.trim()
                    ,globalNotes:this.state.globalNotes.trim()
                    ,isactive:this.state.isActive
                    ,cur_userid:this.props.loginData.Id
                    ,cur_username:this.props.loginData.Name
                })
            })
            .then(response => response.json())
            .then(result => this.setState({ 
                returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", 
                clientId: result.data !== "" ? result.data[0] : "New", 
                returnText: result.message , 
                openModal: true, 
                loading:false 
            }));
        }
    }

    handleDelete = (e) => {
        if(window.confirm("Tem a certeza que quer apagar este cliente?")){
            this.setState({loading:true});
            fetch(API + 'deleteclient&clientid=' + this.state.clientId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false });
            });
        }
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleBirthDateInputChange = (value) => {
        this.setState({ dateOfBirth: value, somethingWasEdited:true });
    }

    handleClientSinceInputChange = (value) => {
        this.setState({ dateClientSince: value, somethingWasEdited:true });
    }

    openServiceModalBox = (clientServiceId) => {
        const serviceModalTitle = clientServiceId === "New" ? "Adicionar Serviço" : this.state.editable ? "Editar Serviço" : "Ver Serviço";
        this.setState({ serviceModalTitle: serviceModalTitle, clientServiceId: clientServiceId, serviceOpenModal: true });
    }

    openClientHistory = () => {
        this.setState({ clinicalHistoryOpenModal: true });
    }

    renderServicesOptions = (e) => {
        const services = this.state.fetchServices;
        if(services===null)
            return;

        const items = [<option value="0" key="0" disabled={true}>Escolha uma opção</option>];
        for (let i=0,n=services.length;i<n;i++) {
            items.push(<option key={services[i].Id} value={services[i].Id}>{services[i].Shortname + " - " + services[i].Name}</option>);
        }
        return items;
    }

    serviceCallBack = (result, keepModalOpen) => {
        if(result !== false){
            this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message, openModal: true, loading:false });
        }
        this.setState({ serviceOpenModal: keepModalOpen, clinicalHistoryOpenModal: keepModalOpen});
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        this.getClientServices();
    }

    deleteClientServiceRow = (clientServiceId) => {
        if(window.confirm("Tem a certeza que quer apagar este serviço?")){
            this.setState({loading:true});
            fetch(API + 'deleteclientservice&clientserviceid=' + clientServiceId + '&clientid=' + this.state.clientId+ "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message, openModal: true, loading:false });
                //$(findDOMNode(this.refs["clientService_" + clientServiceId])).remove();
            });
        }
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const { editable } = this.state;

        const clientServices = this.state.serviceData!=null ? this.state.serviceData : []
              , addEditTitle = this.state.clientId > 0 && this.state.clientData!=null ? this.state.clientData.FirstName + " " + this.state.clientData.LastName : this.state.addEditTitle
              , loadingClass = this.state.loading ? " ajaxLoading" : ""
              , { order, orderBy, rowsPerPage, page } = this.state
              , headerRows = [
                  { id: 'Name', active: true, numeric: false, label: 'Serviço' },
                  { id: 'PriceWithVat', numeric: false, label: 'Valor' },
                  { id: 'DateAppointment', numeric: false, label: 'Marcação' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];        

        return (
            <div id="addEditClientsPage" className={"addEditPage" + loadingClass}>
                <div ref="editForm" className="form">
                    <div className="row">
                        <div className="col-12">
                            <h1><i className="fa fa-address-book"></i> {addEditTitle}
                                { (isAdmin || loginData.profile.Clients.isActive) && 
                                    <span className="float-right">
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    id="isActive"
                                                    checked={!!+this.state.isActive}
                                                    disabled={!(isAdmin || (loginData.profile.Clients.isActive.permission === 1 && editable))}
                                                    onChange={this.handleToggle}
                                                    color="primary"/>
                                            }
                                            label="Ativo"/>
                                    </span>
                                }
                                { (isAdmin || loginData.profile.Clients.canPrint) &&                                 
                                    <Tooltip
                                        title={"Imprimir ficha de cliente"}
                                        enterDelay={200}>
                                        <span className="float-right printHolder">
                                            <NavLink type="button" className="simpleBtn actionButton success" to={{pathname:"/PrintClient/" + this.state.clientId}} target="_blank">Imprimir <i className="fa fa-print fa-2x"></i></NavLink>
                                        </span>
                                    </Tooltip>
                                }
                            </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-sm-4 col-md-2">
                            <figure className="profilePic bigPic">
                                <input type="file" id="uploadPic" onChange={this.handleUploadImage} disabled={!editable} />
                                <img ref="profilePic" src={this.state.profilePic !== "" ? this.state.profilePic : "/img/no_image_available_s.png"} alt={this.state.fullName} title={this.state.fullName} />
                            </figure>
                        </div>
                        <div className="col-12 col-sm-8 col-md-10">
                            <div className="row">
                                <div className="fieldHolder required col-md-4">
                                    <TextField fullWidth
                                               id="firstName"
                                               value={this.state.firstName}
                                               onChange={this.handleFieldChange}
                                               label="Primeiro Nome"
                                               placeholder="Introduza o Primeiro Nome"
                                               disabled={!editable}
                                               data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder required col-md-4">
                                    <TextField fullWidth
                                               id="lastName"
                                               value={this.state.lastName}
                                               onChange={this.handleFieldChange}
                                               label="Último Nome"
                                               placeholder="Introduza o Último Nome"
                                               disabled={!editable}
                                               data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder col-md-4">
                                    <TextField fullWidth
                                               id="profession"
                                               value={this.state.profession}
                                               onChange={this.handleFieldChange}
                                               label="Profissão"
                                               placeholder="Introduza a Profissão"
                                               disabled={!editable}
                                               data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="fieldHolder required col-md-4">
                                    <DatePicker
                                        fullWidth
                                        id="dateClientSince"
                                        label="Data de Inscrição"
                                        format="DD/MM/YYYY"
                                        placeholder="Data de Inscrição"
                                        disabled={!editable}
                                        value={this.state.dateClientSince || null}
                                        locale="pt-PT"
                                        onChange={this.handleClientSinceInputChange}
                                    />
                                </div>
                                <div className="fieldHolder col-md-4">
                                    <DatePicker
                                        fullWidth
                                        id="dateClientRegistered"
                                        label="Data de Registo na App"
                                        format="DD/MM/YYYY"
                                        placeholder="Data de Registo na App"
                                        disabled={true}
                                        value={this.state.dateClientRegistered || null}
                                        onChange={() => null}
                                        locale="pt-PT"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="fieldHolder">
                                <TextField fullWidth
                                           id="fullName"
                                           value={this.state.fullName}
                                           onChange={this.handleFieldChange}
                                           label="Nome Completo"
                                           placeholder="Introduza o Nome Completo"
                                           disabled={!editable} />
                            </div>
                            <div className="fieldHolder required genderOpt">
                                <FormControl component="fieldset">
                                    <FormLabel component="gender">Sexo</FormLabel>
                                    <RadioGroup
                                        className="radioButtonHolder"
                                        name="gender"
                                        value={this.state.gender}
                                        disabled={!editable}
                                        onChange={this.handleRadioChange}>
                                        <FormControlLabel
                                            className="radioButton"
                                            value="M"
                                            label="Masculino"
                                            disabled={!editable}
                                            control={<Radio checkedIcon={<i className="fa fa-male selected"></i>} icon={<i className="fa fa-male"></i>} />} />
                                        <FormControlLabel
                                            className="radioButton"
                                            value="F"
                                            label="Feminino"
                                            disabled={!editable}
                                            control={<Radio checkedIcon={<i className="fa fa-female selected"></i>} icon={<i className="fa fa-female"></i>} />} />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="row">
                                <div className="fieldHolder col-md-6">
                                    <DatePicker
                                        fullWidth
                                        id="dateOfBirth"
                                        label="Data de Nascimento"
                                        format="DD/MM/YYYY"
                                        placeholder="Data de Nascimento"
                                        disabled={!editable}
                                        value={this.state.dateOfBirth || null}
                                        locale="pt-PT"
                                        onChange={this.handleBirthDateInputChange}
                                    />
                                </div>
                                <div className="col-md-6 buttonsHolder text-center">
                                    <Button onClick={this.openClientHistory}
                                            className="button" label="Historial"
                                            title="Ver historial clínico do cliente"
                                            disabled={!(isAdmin || loginData.profile.Clients.clientHistory)}
                                            variant="contained" color="primary">
                                        <i className='fa fa-history'></i> 
                                        Historial
                                    </Button>
                                </div>                                
                            </div>
                            <div className="row">
                                <div className="fieldHolder col-md-6">
                                    <TextField fullWidth
                                               id="homePhone"
                                               value={this.state.homePhone}
                                               onChange={this.handleFieldChange}
                                               label="Número de telefone fixo"
                                               placeholder="Introduza o telefone fixo"
                                               disabled={!editable} />
                                </div>
                                <div className="fieldHolder required col-md-6">
                                    <TextField fullWidth
                                               id="cellPhone"
                                               value={this.state.cellPhone}
                                               onChange={this.handleFieldChange}
                                               label="Número de telemóvel"
                                               placeholder="Introduza o telemóvel"
                                               disabled={!editable}
                                               data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                            </div>
                            <div className="fieldHolder required validEmail">
                                <TextField fullWidth
                                           id="email"
                                           value={this.state.email}
                                           onChange={this.handleFieldChange}
                                           label="Email"
                                           placeholder="Introduza o Email"
                                           disabled={!editable}
                                           data-email-error-message="Este email não está correto."
                                           data-empty-error-message="Este campo não pode estar vazio" />
                            </div>
                            <div className="fieldHolder">
                                <TextField fullWidth
                                           id="homeAddress"
                                           value={this.state.homeAddress}
                                           onChange={this.handleFieldChange}
                                           disabled={!editable}
                                           multiline
                                           rows={4}
                                           label="Morada de casa" />
                            </div>
                            <div className="fieldHolder hidden-md-down">
                                <TextField fullWidth
                                           id="notes"
                                           value={this.state.notes}
                                           onChange={this.handleFieldChange}
                                           disabled={!editable}
                                           multiline
                                           rows={4}
                                           label="Observações" />
                            </div>
                            <div className="fieldHolder hidden-md-down redField">
                                { (isAdmin || loginData.profile.Clients.globalNotes) &&
                                    <TextField fullWidth
                                        id="globalNotes"
                                        value={this.state.globalNotes}
                                        onChange={this.handleFieldChange}
                                        disabled={!(isAdmin || (loginData.profile.Clients.globalNotes.permission === 1 && editable))}
                                        multiline
                                        rows={4}
                                        className="importantNoticeTextfield"
                                        label="Observações Globais" />
                                }
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="row">
                                <div className="fieldHolder col-md-6">
                                    <TextField fullWidth
                                               id="cId"
                                               value={this.state.cId}
                                               onChange={this.handleFieldChange}
                                               label="Id Interno"
                                               placeholder="Introduza o Id Interno do cliente"
                                               disabled={this.props.loginData.AccessLevel >= 1} />
                                </div>
                                <div className="fieldHolder col-md-6">
                                    <TextField fullWidth
                                               id="invoiceNumber"
                                               value={this.state.invoiceNumber}
                                               onChange={this.handleFieldChange}
                                               label="Número da Fatura"
                                               placeholder="Número da Fatura"
                                               disabled={!editable} />
                                </div>
                                <div className="fieldHolder col-md-6">
                                    <TextField fullWidth
                                               id="idNumber"
                                               value={this.state.idNumber}
                                               onChange={this.handleFieldChange}
                                               label="Cartão de Cidadão"
                                               placeholder="Introduza CC"
                                               disabled={!editable} />
                                </div>
                                <div className="fieldHolder col-md-6">
                                    <TextField fullWidth
                                               id="financeNumber"
                                               value={this.state.financeNumber}
                                               onChange={this.handleFieldChange}
                                               label="Identificação Fiscal"
                                               placeholder="Introduza o NIF"
                                               disabled={!editable} />
                                </div>
                            </div>
                            <div className="fieldHolder">
                                <TextField fullWidth
                                           id="iban"
                                           value={this.state.iban}
                                           onChange={this.handleFieldChange}
                                           label="Número de IBAN"
                                           placeholder="Introduza o Número de Identificação Bancária"
                                           disabled={!editable} />
                            </div>
                            <div className="fieldHolder hidden-md-up">
                                <TextField fullWidth
                                           id="notes"
                                           value={this.state.notes}
                                           onChange={this.handleFieldChange}
                                           disabled={!editable}
                                           multiline
                                           rows={4}
                                           label="Observações" />
                            </div>
                            <div className="fieldHolder hidden-md-up redField">
                                { (isAdmin || loginData.profile.Clients.globalNotes) &&
                                    <TextField fullWidth
                                        id="globalNotes"
                                        value={this.state.globalNotes}
                                        onChange={this.handleFieldChange}
                                        disabled={!(isAdmin || (loginData.profile.Clients.globalNotes.permission === 1 && editable))}
                                        multiline
                                        rows={4}
                                        label="Observações Globais" />
                                }
                            </div>
                            { (isAdmin || loginData.profile.Clients.clientServices) && 
                                <div>
                                    <div className="tableHolder">
                                        <div className="tableHeader">
                                            <div className="olderDatesHolder">
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            id="getOldClientServices"
                                                            checked={!!+this.state.getOldClientServices}
                                                            disabled={!editable}
                                                            onChange={this.handleOldServiceChange}
                                                            color="primary"/>
                                                    }
                                                    label="Ver Marcações Antigas"/>
                                            </div>
                                            <h2><i className="fa fa-clipboard-list"></i> Serviços Adquiridos 
                                                { (isAdmin || loginData.profile.Clients.clientServicesADD) && this.state.clientId > 0 &&
                                                    <Tooltip
                                                        title={"Adicionar Serviço"}
                                                        enterDelay={200}>
                                                        <span className="float-right">
                                                            <button type="button" 
                                                                    className="simpleBtn actionButton success" 
                                                                    onClick={() => this.openServiceModalBox("New")}>
                                                                        <i className="fa fa-plus"></i>
                                                            </button>
                                                        </span>
                                                    </Tooltip>
                                                }
                                            </h2>
                                        </div>
                                        <Table className={"responsiveTable customTable originalTable" + loadingClass}>
                                            <EnhancedTableHead
                                                className="tableRow tableHeader"
                                                headerRows={headerRows}
                                                order={order}
                                                orderBy={orderBy}
                                                onRequestSort={this.handleRequestSort}
                                                rowCount={clientServices.length}>
                                            </EnhancedTableHead>
                                            <TableBody>
                                                {stableSort(clientServices, getSorting(order, orderBy))
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map(clientService => {
                                                        const isChild = clientService.ParentId !== "0";
                                                        return (
                                                            <TableRow key={clientService.Id} className={"tableRow" + (!+clientService.IsActive ? " inactive" : "")} ref={"service_" + clientService.Id}>
                                                                <TableCell data-title="Serviço" className="tableCell"><span className={clientService.IsPack==="1" ? "font-bold" : ""}>
                                                                    {isChild &&
                                                                        <Tooltip
                                                                            title={"Este serviço faz parte de um pacote"}
                                                                            enterDelay={200}>
                                                                            <span className="packIcon"><i className="fas fa-list-ol"></i></span>
                                                                        </Tooltip> 
                                                                    }
                                                                    {clientService.Name} {clientService.IsPack==="1" && clientService.Children > 0 ? "("+clientService.Children+")" : ""}</span>
                                                                </TableCell>
                                                                <TableCell data-title="Valor" className={"tableCell clientServiceValue " + (clientService.ValueMissing==="0" ? "allPaid" : "")}>
                                                                    {parseFloat(clientService.PriceWithVat).toFixed(2) + "€"}
                                                                    {clientService.ValueMissing === "0" ? "" : <span><br/><span className="valueMissing">({parseFloat(clientService.ValueMissing).toFixed(2) + "€"})</span></span>}
                                                                </TableCell>
                                                                <TableCell data-title="Marcação" className="tableCell appointment">
                                                                    <div className="row">
                                                                        <div className="col-7">{clientService.AppointmentId!==null ? clientService.DateAppointment + " " + clientService.HoursAppointment : "Não tem"}</div>
                                                                        <div className="col-3">
                                                                            { clientService.AppointmentId !== null ?
                                                                                    (isAdmin || loginData.profile.Appointments.permission === 1) && isFutureDate(new Date(clientService.DateAppointment + " " + clientService.HoursAppointment)) ?
                                                                                        <Tooltip
                                                                                            title={"Editar Marcação"}
                                                                                            enterDelay={200}>
                                                                                            <span><NavLink className="actionButton warning" to={{pathname:"/Appointments/" + clientService.AppointmentId, blockDates:true, staffId:clientService.StaffId, appDate:clientService.DateAppointment, appHour:clientService.HoursAppointment.slice(0, -3), clientId: clientService.ClientId}}><i className="fa fa-calendar"></i></NavLink></span>
                                                                                        </Tooltip>
                                                                                        :
                                                                                        <Tooltip
                                                                                            title={"Ver Marcação"}
                                                                                            enterDelay={200}>
                                                                                            <span><NavLink className="actionButton success" to={{pathname:"/Appointments/" + clientService.AppointmentId, blockDates:true, staffId:clientService.StaffId, appDate:clientService.DateAppointment, appHour:clientService.HoursAppointment.slice(0, -3), clientId: clientService.ClientId}}><i className="fa fa-eye"></i></NavLink></span>
                                                                                        </Tooltip>
                                                                                :
                                                                                (isAdmin || loginData.profile.Appointments.ADD) && (clientService.IsPack==="0" || (clientService.IsPack==="1" && clientService.Children > 0)) &&
                                                                                <Tooltip
                                                                                    title={"Agendar Serviço"}
                                                                                    enterDelay={200}>
                                                                                    <span><NavLink className="actionButton success" disabled={!+clientService.IsActive} to={{pathname:"/Appointments/New", clientId:clientService.ClientId, isClientService: "1", isPack:clientService.IsPack==="1", appMaxDur:(parseInt(clientService.Children, 10) * 30), priceWithVat:clientService.PriceWithVat, priceWithoutVat:clientService.PriceWithoutVat, serviceId:clientService.ServiceId, blockClientService:true}}><i className="fa fa-calendar-plus"></i></NavLink></span>
                                                                                </Tooltip>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell data-title="Ações" className="tableCell actions" data-row-id={clientService.Id}>
                                                                    { (isAdmin || loginData.profile.Clients.clientServices.permission === 1) ?
                                                                        <Tooltip
                                                                            title={ isChild ? "Editar Pacote" : "Editar Serviço" }
                                                                            enterDelay={200}>
                                                                            <span><button type="button" className="simpleBtn actionButton warning" onClick={() => { isChild ? this.openServiceModalBox(clientService.ParentId) : this.openServiceModalBox(clientService.Id)}}><i className="fa fa-pencil-alt"></i></button></span>
                                                                        </Tooltip>
                                                                       : 
                                                                        <Tooltip
                                                                            title={ isChild ? "Ver Pacote" : "Ver Serviço" }
                                                                            enterDelay={200}>
                                                                            <span><button type="button" className="simpleBtn actionButton success" onClick={() => this.openServiceModalBox(clientService.Id)}><i className="fa fa-eye"></i></button></span>
                                                                        </Tooltip>
                                                                    }
                                                                    { (isAdmin || loginData.profile.Clients.clientServicesDEL) &&
                                                                        <Tooltip
                                                                            title={ isChild ? "Eliminar Pacote" : "Eliminar Serviço" }
                                                                            enterDelay={200}>
                                                                            <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteClientServiceRow(clientService.Id)}><i className="fa fa-times"></i></button></span>
                                                                        </Tooltip>
                                                                    }
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    }
                                                )}
                                            </TableBody>
                                        </Table>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25]}
                                                component="div"
                                                count={clientServices.length}
                                                rowsPerPage={rowsPerPage}
                                                labelRowsPerPage="Linhas por página:"
                                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                                                page={page}
                                                backIconButtonProps={{
                                                    'aria-label': 'Página anterior',
                                                }}
                                                nextIconButtonProps={{
                                                    'aria-label': 'Próxima página',
                                                }}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 buttonsHolder">
                            <Button onClick={this.props.props.history.goBack} variant="contained" className="defaultButton">Voltar</Button>
                            { (isAdmin || loginData.profile.Clients.DEL) && this.state.clientId !== "New" && <Button onClick={this.handleDelete} className="button button-danger" variant="contained">Apagar Cliente</Button>}
                            { editable && <Button onClick={this.handleSave} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                        </div>
                    </div>
                </div>
                {this.state.serviceOpenModal && <ServiceModalBox modalCallBack={this.serviceCallBack} modalTitle={this.state.serviceModalTitle} websiteSettings={this.props.websiteSettings} serviceData={this.state.fetchServices} clientServiceId={this.state.clientServiceId} clientId={this.state.clientId} loginData={this.props.loginData} accessLevel={this.props.loginData.AccessLevel} canDelete={isAdmin || (loginData.profile.Clients.clientServicesDEL && editable)} editable={isAdmin || (loginData.profile.Clients.clientServices.permission === 1 && editable)} />}
                {this.state.clinicalHistoryOpenModal && <ClinicalHistoryModalBox modalCallBack={this.serviceCallBack} clientId={this.state.clientId} loginData={this.props.loginData} accessLevel={this.props.loginData.AccessLevel} editable={isAdmin || (loginData.profile.Clients.clientHistory.permission === 1 && editable)} />}
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default AddEditClient;
